import React from 'react';
import { MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { values } from 'lodash';

import Select from 'components/@common/Inputs/Select';
import { CharacterErrorType } from '../../../types';

interface ErrorTypePickerProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ErrorTypePicker: React.FC<ErrorTypePickerProps> = ({ value, onChange }) => {
  const { t } = useTranslation('Reports');
  return (
    <Select
      placeholder={t('All')}
      value={value}
      size="small"
      name="errorType"
      inputProps={{
        'aria-label': t('Select the Error Type')
      }}
      onChange={onChange}
    >
      <MenuItem value={undefined}>{t('All')}</MenuItem>
      {values(CharacterErrorType).map(option => (
        <MenuItem key={`${option}-error-type-option`} value={option}>
          {t(option, { ns: 'CharacterErrorType' })}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ErrorTypePicker;
